import styles from "./YouveViewed.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export function YouveViewed({
  resultsInfo,
  positionOnPage,
  className,
}: {
  resultsInfo: {
    start: number;
    total: number;
  };
  positionOnPage: number;
  className?: string;
}) {
  if (!resultsInfo.total) {
    return null;
  }

  // Calculate the position of the product in the total list of all products retrieved
  // e.g. for a page size of 192, the first product on page 2 is product 193
  // Note that positionOnPage is zero-based, so we add 1 to it
  // i.e. positionOnPage 0 is product 1 on that page
  const productPositionInList = resultsInfo.start + positionOnPage + 1;

  return (
    <small
      data-component="YouveViewed"
      className={cx("youveViewed", className)}
      data-testid="youve-viewed"
    >
      {`You've viewed ${productPositionInList.toLocaleString(
        "en",
      )} of ${resultsInfo.total.toLocaleString("en")}`}
    </small>
  );
}
